import { Button, Col, Text, useTheme } from "@rally/ui-kit";
import { useEffect, useState } from "react";
import { Faces } from "../chat/person/faces.tsx";
import { GUTTER } from "../chat/reading.ts";
import { say } from "../localization/say.ts";
import type { PersonInCall } from "./calling.ts";

export function lengthOf(from: string, to: number = Date.now()): string {
  const seconds = Math.max(0, Math.floor((to - new Date(from).getTime()) / 1000));
  const minutes = Math.floor(seconds / 60);
  return `${minutes}:${String(seconds % 60).padStart(2, "0")}`;
}

function useClock(from: string | null): string {
  const [said, setSaid] = useState(() => (from ? lengthOf(from) : ""));
  useEffect(() => {
    if (!from) return;
    setSaid(lengthOf(from));
    const timer = setInterval(() => setSaid(lengthOf(from)), 1000);
    return () => clearInterval(timer);
  }, [from]);
  return said;
}

export function CallStrip({
  startedAt,
  here,
  me,
  joined,
  onJoin,
}: {
  startedAt: string | null;
  here: readonly PersonInCall[];
  me: string;
  joined: boolean;
  onJoin: () => void;
}) {
  const theme = useTheme();
  const clock = useClock(startedAt);
  const inIt = here.filter((one) => one.here);

  return (
    <Col
      testID="call-strip"
      style={{
        flexDirection: "row",
        alignItems: "center",
        gap: theme.space[3],
        paddingHorizontal: GUTTER,
        paddingVertical: theme.space[2],
        backgroundColor: theme.color.accentSoft,
        borderBottomWidth: 1,
        borderBottomColor: theme.color["border.default"],
      }}
    >
      <Faces people={inIt} me={me} size={20} testID="call-strip-faces" />
      <Text typeName="caption" color="text.secondary" numberOfLines={1} style={{ flex: 1 }}>
        <Text typeName="caption" color="text.primary" testID="call-strip-length">
          {clock}
        </Text>
        {"  "}
        {say("call.here")(inIt.length)}
      </Text>
      {joined ? (
        <Text typeName="caption" color="text.secondary" testID="call-strip-mine">
          {say("call.youAreIn")}
        </Text>
      ) : (
        <Button size="sm" variant="soft" onPress={onJoin} testID="call-join">
          {say("call.join")}
        </Button>
      )}
    </Col>
  );
}
